import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const BooleanFunctionsCanonicalStandardForms = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      title="Boolean Functions, Canonical and Standard Forms"
      videos={[
        "https://www.youtube.com/embed/MhWxPLwAsPA"
      ]}
      takeaways={[]}
      questions={[
        "Implement the simplified expression of the Boolean Function F(w,x,y,z) = ∑m(0,1,4,8,9,10) + ∑d(2,11) using basic gates"
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default BooleanFunctionsCanonicalStandardForms;
